const POPOUT_WINDOW_WIDTH = 1000;
const POPOUT_WINDOW_HEIGHT = 700;

// Start window creation directly from the user's click. Both Document PiP and
// popup blockers rely on transient user activation that may be lost in an
// effect scheduled after the event handler returns.
export const openWidgetPopoutWindow = async () => {
  if (window.documentPictureInPicture?.requestWindow) {
    try {
      return await window.documentPictureInPicture.requestWindow({
        width: POPOUT_WINDOW_WIDTH,
        height: POPOUT_WINDOW_HEIGHT,
      });
    } catch (error) {
      console.warn('Document Picture-in-Picture unavailable, using a popup window:', error);
    }
  }

  return window.open(
    '',
    '_blank',
    `popup=yes,width=${POPOUT_WINDOW_WIDTH},height=${POPOUT_WINDOW_HEIGHT}`,
  );
};
